import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
//@ts-ignore
import moment from "moment";
import { useForm } from "react-hook-form";
import { orderRemarksValidationForm } from "../../../utils/validationSchemas";
import Button from "../../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const Bulk_Comment = ({ handleActionMenu, isLoading }: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    reset,
  } = useForm<any>({
    resolver: yupResolver(orderRemarksValidationForm),
  });

  // copied code from https://flowbite.com/blocks/publisher/comments/

  return (
    <>
      <section className={tw`bg-white  mt-10`}>
        <div className={tw`max-w-2xl mx-auto px-4 `}>
          <div className={tw`sticky top-4`}>
            <form className={tw`mb-6`}
            onSubmit={handleSubmit((data: any) =>
              handleActionMenu(data, "Bulk Comment", setError)
            )} autoComplete="off"
            >
              <div
                className={tw`py-2 px-4 mb-4 bg-white rounded-lg rounded-t-lg border border-gray-200 `}
              >
                <textarea
                  id="comment"
                  rows={6}
                  {...register("comment")}
                  className={tw`px-0 w-full text-sm bg-white text-gray-900 border-0 focus:ring-0 focus:outline-none `}
                  placeholder="Write a comment..."
                ></textarea>
                {errors?.comment && (
                  <p className={tw`text-red-500 text-xs my-1`}>
                    {errors?.comment?.message}
                  </p>
                )}
              </div>
              <div className={tw`flex justify-end w-full`}>
                <div className={tw`w-[100px] mr-4`}>
                  <Button
                    label={"Create"}
                    isLoading={isLoading}
                   
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Bulk_Comment;
